import request from './config'

export function getIndexData() {
    return request({
        url: '/index/data'
    })
}

export function getCode() {
    return request({
        url: '/index/captcha'
    })
}

export function sendDeveloperInfo({
    game_name,
    status,
    game_link,
    app_platform,
    gameplay_video_link,
    about_game,
    team_name,
    team_size,
    team_website,
    development_platform,
    full_name,
    email,
    skype_id,
    language,
    country,
    en,
    captcha
}) {
    return request({
        url: '/index/developers',
        method: 'post',
        data: {
            game_name,
            status,
            game_link,
            app_platform,
            gameplay_video_link,
            about_game,
            team_name,
            team_size,
            team_website,
            development_platform: development_platform.join(),
            full_name,
            email,
            skype_id,
            language,
            country,
            en,
            captcha
        }
    })
}